module.exports = __webpack_public_path__ + "static/media/account-image3.28c24165.png";